export const buildElementId = (type = '', hotspotId = '') =>
  `${type}_${hotspotId}`;
